import createSvgIcon from "./createSvgIcon";
import React from "react";

export default createSvgIcon(
  <g>
    <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" />{" "}
    <path fill="none" d="M0 0h24v24H0z" />
  </g>,
  "SwapArrow"
);
